import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll';

const Initialization = () => {
    return (
      <div
        style={{
          margin: "20vh 0",
          backgroundColor: "rgb(34, 112, 145, 0.7)",
          borderRadius: "2rem",
          padding: "1rem",
        }}
      >
        <Grid container>
          <Grid item container>
            <Grid item container justify={"center"}>
              <ScrollAnimation animateIn="fadeIn" delay={300}>
                <Typography
                  variant="h4"
                  style={{
                    color: "#01a3a4",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginTop: "5rem",
                    textShadow: "5px 2px 3px black",
                  }}
                >
                  Tokennomics
                </Typography>
              </ScrollAnimation>
            </Grid>

            <Grid
              container
              item
              xs={12}
              md={6}
              justify="center"
              style={{ padding: "20px" }}
            >
              <ScrollAnimation animateIn="fadeIn" delay={400}>
                <Typography
                  variant="h4"
                  style={{
                    color: "#ee5253",
                    fontWeight: "bold",
                    textShadow: "5px 2px 3px black",
                  }}
                >
                  10 Quadrillion Supply
                </Typography>
              </ScrollAnimation>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              container
              justify={"center"}
              alignContent="center"
            >
              <ScrollAnimation animateIn="fadeIn" delay={400}>
                <Typography
                  variant="h4"
                  style={{
                    color: "#ee5253",
                    fontWeight: "bold",
                    textShadow: "5px 2px 3px black",
                  }}
                >
                  90% Burn
                </Typography>
              </ScrollAnimation>
            </Grid>
          </Grid>
          <Grid item container md={6}>
            <ScrollAnimation
              animateIn="bounceInLeft"
              animateOut="bounceOutRight"
              delay={600}
            >
              <Typography
                variant="h6"
                style={{
                  color: "#ffb142",
                  textAlign: "left",
                  margin: "2rem",
                  textShadow: "2px 2px 3px black",
                }}
              >
                Community-owned crypto, Dev Wallet is locked for 12 months, 8%
                is reserved for purchasing advertisement spaces and
                collaboration with influencers.
                <ul>
                  <li>85% Community Wallet</li>
                  <li>8% Marketing Wallet</li>
                  <li>7% Dev Wallet</li>
                  <li>Deploy Smart Contract</li>
                  <li>Fair Launch(On Pancakeswap)</li>
                  <li>CoinGecko Listing</li>
                  <li>Community Marketing Fund</li>
                  <li>Reach JustSmile TG members</li>
                  <li>Airdrop</li>
                </ul>
              </Typography>
            </ScrollAnimation>
          </Grid>
          <Grid item container md={6} justify="center">
            <ScrollAnimation
              animateIn="bounceInRight"
              animateOut="bounceOutLeft"
              delay={600}
            >
              <Typography
                variant="h6"
                style={{
                  color: "#ffb142",
                  textAlign: "left",
                  margin: "2rem",
                  textShadow: "5px 2px 3px black",
                }}
              >
                Why Choose Us?
                <ul>
                  <li>Experienced Developers</li>
                  <li>Effective Process</li>
                  <li>Trusted and Proven Track Record</li>
                  <li>Strong Industry Network</li>
                </ul>
              </Typography>
            </ScrollAnimation>
          </Grid>
        </Grid>
      </div>
    );
}

export default Initialization